import { Box } from '@mui/material';
import React from 'react';
import { SpaceOption } from '../../types';
import { NameField } from './NameField';
import { SpaceSelector } from './SpaceSelector';

interface FluxbotFormProps {
  name: string;
  onNameChange: (value: string) => void;
  selectedSpaceId: string;
  onSpaceChange: (value: string) => void;
  spaces: SpaceOption[];
  disabled?: boolean;
}

export const FluxbotForm: React.FC<FluxbotFormProps> = ({
  name,
  onNameChange,
  selectedSpaceId,
  onSpaceChange,
  spaces,
  disabled = false,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <NameField
        value={name}
        onChange={onNameChange}
        placeholder='Name your fluxbot'
        disabled={disabled}
      />
      <SpaceSelector
        value={selectedSpaceId}
        onChange={onSpaceChange}
        spaces={spaces}
        disabled={disabled}
        required
      />
    </Box>
  );
};
